import { css } from 'linaria';
import { styled } from 'linaria/react';
import type { AdBadgeProps, AdBadgeVariant } from './types';

const setVariantStyles = (variant: AdBadgeVariant) => {
  switch (variant) {
    case 'text':
      return {
        background: 'var(--text-minor_opacity-6)',
      };
    case 'icon':
    default:
      return {
        background: 'transparent',
      };
  }
};

export const CaptionBlock = styled.div<AdBadgeProps>`
  display: flex;
  padding-block: var(--space-25);
  padding-inline: var(--space-75);
  /* stylelint-disable-next-line custom-property-pattern -- Пришлось отключить, т.к. stylelint не признает snake_case, токен Fronton мы изменить не можем, а отказываться от токена в пользу голого стиля - не очень хорошо */
  background: ${({ variant = 'text' }) => setVariantStyles(variant).background};
  border-radius: var(--rounding-m);
  z-index: 1;
  cursor: default;
  user-select: none;
`;

export const captionText = css`
  font-size: 10px !important;
  line-height: 14px !important;
  letter-spacing: 0.2px;
  color: #fff;

  @media (--only-tablet) {
    font-size: 9px !important;
  }
`;
